//API serivice FUNCTIONS
import { notification } from "antd";
import moment from "moment";
import { getFromLocalStorage, setToLocalStorage } from "../../Helpers/helpers";
import { error, success } from "../../Helpers/notification";
import { changeAccessControl, changePlant, changeValidation } from "../../Redux/features/plant.slice";
import { setRoleList } from "../../Redux/features/roles.slice";
import { setComponentLoader, setComponentReloader, setPageLoader } from "../../Redux/features/utils.slice";
import { deleteRequest, postRequest } from "../apiMethods";
import { apiRoutes } from "../apiRoutes"
import { onPlantChange, getAllPlants, updatePlants } from "./plants.api";
import { getRolesList } from "./roles.api";
import { generateId } from "../../Utils/generateId";
const { plantSettings, plants, roles, shifts, alerts, productionLine } = apiRoutes;

const moduleGenerateId = (module, body, data) => {
    return getModuleConfig(module, body).idGenerator(data);
  };

const getModuleConfig = (module, params) => {
    let idGenerator = () => generateId(`${module.substr(0, 2)}`); // <== @todo: REPLACE THIS WITH UUID
    let db;
    switch (module) {
      case 'plant':
        idGenerator = ({ plantName }) => generateId('', { slug: plantName }); // should generate slug from data.name
        break;
  
      case 'productionLine':
        idGenerator = ({ lineName }) => generateId('', { slug: lineName }); // should generate slug from data.name
        break;

      case 'logs':
        idGenerator = ({ lineName, timestamp, userId }) => generateId('', { slug: lineName + userId + timestamp }); // should generate slug from data.name
        break;
  
      default:
        break;
    }
    
    return { db, idGenerator };
  };

  const deleteRecord = async (idLabel, valueId, current, dispatch) => {
      const currentTime = new Date();
    
      if(idLabel == '_id'){
    let payloads = {
        first:{
        endPoint: plants.update,
        body:{
            type: "deleted",
            updatedAt: currentTime,
            _id: valueId
            }
            }
        }
        let deletePlant = await postRequest(payloads.first)
    }
    else{

        let payloads = {
            first: {
                endPoint: productionLine.update,
                body:{
                    plantId: current?.plant?._id,
                    type: "deleted",
                    updatedAt: currentTime,
                    _id: valueId
                }
            }
        }
        let deleteLine = await postRequest(payloads.first)
    }
}

const createPlant = async (module, dispatch, body) => {
    let id = body && body._id ? body._id : moduleGenerateId(module, body, body)
    body = {...body, _id:id}
    //console.log(body);
    if(module === 'plant'){
    let response = await postRequest({
        endPoint: plants.create,
        body: body
    })
    if (response.success === true) {
    let plants = getFromLocalStorage('plants')
    plants = [...plants,body]
    
    setToLocalStorage(plants, 'plants')
    }
    }
    if(module === 'productionLine'){
        
        let response = await postRequest({
            endPoint: productionLine.create,
            body: body
        })
        if (response.success === true) {
            if (!body?.currentPlant?.productionLines) 
            body.currentPlant.productionLines = [];
            body?.currentPlant?.productionLines.push({
                id: body?._id,
                lineName: body?.lineName,
                hallName: body?.hallName,
              });

              let response2 = await postRequest({
                endPoint: plants.update,
                body:body?.currentPlant
            })
            let current = getFromLocalStorage('current')
            current.plant = body?.currentPlant;
            setToLocalStorage(current, 'current')
          
            let lines = getFromLocalStorage('lines')
            lines = [...body?.currentPlant?.productionLines]
            setToLocalStorage(lines, 'lines')
            
            let halls = lines?.map((line, index) => (
                { hallName: line?.hallName, lineId: line?.id, index }
            ))
            setToLocalStorage(halls, 'halls')
            dispatch(changePlant(
                {
                    halls,
                    lines,
                    machines: lines[0]?.machines,
                    current
                }
            ))
            }

    }
}

const onAddUserSubmit = async (dispatch, bodyAddUser, bodyUpdateAccessControl) => {
    dispatch(setPageLoader({ page: 'addUser', flag: true }))


    let response = await postRequest({
        endPoint: plantSettings.addUser,
        body: bodyAddUser
    })
    //Update Access Control
    let response2 = await postRequest({
        endPoint: plantSettings.updateAccessControl,
        body: bodyUpdateAccessControl
    })
    if (response2.success === true && response.success === true) {
        let current = getFromLocalStorage('current')
        let plants = getFromLocalStorage('plants')
        let { plant } = current;
        let filteredPlants = plants.filter(data => data._id !== plant?._id)
        plant = { ...plant, accessControl: bodyUpdateAccessControl.accessControl }
        current = { ...current, plant }
        plants = [plant, ...filteredPlants]
        // console.log(plants, plant)
        setToLocalStorage(current, 'current')
        setToLocalStorage(plants, 'plants')
        dispatch(changeAccessControl({ current, plants }))
    }
    dispatch(setPageLoader({ page: 'addUser', flag: false }))

}

const onDeleteUserSubmit = async (dispatch, body) => {

    dispatch(setPageLoader({ page: 'deleteUser', flag: true }))
    let response = await postRequest({
        endPoint: plantSettings.updateAccessControl,
        body
    })
    if (response.success === true) {
        let current = getFromLocalStorage('current')
        let plants = getFromLocalStorage('plants')
        let { plant } = current;

        let filteredPlants = plants.filter(data => data._id !== plant?._id)
        plant = { ...plant, accessControl: body.accessControl }
        plants = [plant, ...filteredPlants]
        current = { ...current, plant }
        // console.log({ current, plants })
        setToLocalStorage(current, 'current')
        setToLocalStorage(plants, 'plants')
        dispatch(changeAccessControl({ current, plants }))
    }
    dispatch(setPageLoader({ page: 'deleteUser', flag: false }))
}

const onEditUserSubmit = async (dispatch, body) => {

    dispatch(setPageLoader({ page: 'editUser', flag: true }))
    let response = await postRequest({
        endPoint: plantSettings.updateAccessControl,
        body
    })
    if (response.success === true) {
        let current = getFromLocalStorage('current')
        let plants = getFromLocalStorage('plants')
        let { plant } = current;

        let filteredPlants = plants.filter(data => data._id !== plant?._id)
        plant = { ...plant, accessControl: body.accessControl }
        plants = [plant, ...filteredPlants]
        current = { ...current, plant }
        // console.log({ current, plants })
        setToLocalStorage(current, 'current')
        setToLocalStorage(plants, 'plants')
        dispatch(changeAccessControl({ current, plants }))
    }
    dispatch(setPageLoader({ page: 'editUser', flag: false }))
}

const onValidationSubmit = async (dispatch, body) => {

    dispatch(setPageLoader({ page: 'validation', flag: true }))
    let response = await postRequest({
        endPoint: plants.update,
        body
    })
    if (response.success === true) {
        let current = getFromLocalStorage('current')
        let plants = getFromLocalStorage('plants')
        let { plant } = current;

        let filteredPlants = plants.filter(data => data._id !== plant?._id)
        plant = { ...plant, validations: body.validations }
        plants = [plant, ...filteredPlants]
        current = { ...current, plant }
        // console.log({ current, plants })
        setToLocalStorage(current, 'current')
        setToLocalStorage(plants, 'plants')
        dispatch(changeValidation({ current, plants }))
    }
    dispatch(setPageLoader({ page: 'validation', flag: false }))

}

const createProduct = async (dispatch, body, current) => {

    dispatch(setComponentLoader({ component: 'productModal', flag: true }))
    let currentUser = getFromLocalStorage('user');
    let { productSettings } = current.plant
    let { lineOps } = body;
    let lines = []
    lineOps.forEach((op) => {
        body.lines.forEach((line) => {
            if (line == op.value)
                lines.push({ lineName: op.label, id: op.value })
        })
    })
    let payloads = {
        create: {
            detailsAfter: {
                name: body.name,
                sku: body.sku,
                primary: body.primary,
                secondary: body.secondary,
            },
            action: 'Product Created',
            email: currentUser?.username,
            hallName: current?.hall?.hallName,
            lineName: current?.line?.lineName,
            lineId: current?.line?.id,
            plantName: current?.plant?.plantName,
            plantId: current?.plant?._id,
            shiftName: current?.shift?.name,
            time: `${moment(Date.now()).format(`${"YYYY-MM-DDThh:mm:ss.ms"}`)}Z`,
            userId: "test132",
        },
        update: {
            _id: current?.plant?._id,
            updatedAt: `${moment(new Date()).format("YYYY-MM-DDThh:mm:ss.ms")}Z`,
            productSettings: [
                ...productSettings,
                {
                    name: body.name,
                    sku: body.sku,
                    primary: body.primary,
                    secondary: body.secondary,
                }], 
        },
    }

    try {

        let updatePlantRes = await postRequest({
            endPoint: plants.update,
            body: payloads['update']
        })


        let createProductRes = await postRequest({
            endPoint: shifts.create,
            body: payloads['create']
        })

        if (updatePlantRes.success === true && createProductRes.success === true) {
            let { plant } = getFromLocalStorage('current')
            let plantToUpdate = { ...plant, productSettings: payloads.update.productSettings }
            updatePlants(plantToUpdate, plantToUpdate?._id, dispatch)
            success('Product Created.')
        }
    }
    catch (exc) {
        notification.error(exc.message)
    }
    dispatch(setComponentLoader({ component: 'productModal', flag: false }))
}

const editProduct = async (dispatch, body, current) => {

    dispatch(setComponentLoader({ component: 'productModal', flag: true }))
    let currentUser = getFromLocalStorage('user');
    let { productSettings } = current.plant
    let { lineOps, rec, values } = body;
    let lines = []
    lineOps.forEach((op) => {
        values.lines.forEach((line) => {
            if (line.value) {
                if (line.value == op.value)
                    lines.push({ lineName: op.label, id: op.value })
            }
            else {
                if (line == op.value)
                    lines.push({ lineName: op.label, id: op.value })
            }
        })
    })
    const newProductSettings = productSettings.filter(item => JSON.stringify(rec) !== JSON.stringify(item));
    let payloads = {
        create: {
            detailsBefore: { ...rec },
            detailsAfter: {
                name: values.name,
                sku: values.sku,
                primary: values.primary,
                secondary: values.secondary,
            },
            action: 'Product Updated',
            email: currentUser?.username,
            hallName: current?.hall?.hallName,
            lineName: current?.line?.lineName,
            lineId: current?.line?.id,
            plantName: current?.plant?.plantName,
            plantId: current?.plant?._id,
            shiftName: current?.shift?.name,
            time: `${moment(Date.now()).format(`${"YYYY-MM-DDThh:mm:ss.ms"}`)}Z`,
            userId: "test132",
        },
        update: {
            productSettings: [
                ...newProductSettings,
                {
                    name: body.name,
                    toValue: body.toValue,
                    product: body.product,
                    lines: lines,
                    fromTime: body.fromTime,
                    toTime: body.toTime,
                }],
            _id: current?.plant?._id,
            updatedAt: `${moment(new Date()).format("YYYY-MM-DDThh:mm:ss.ms")}Z`
        },
    }

    try {

        let updatePlantRes = await postRequest({
            endPoint: plants.update,
            body: payloads['update']
        })


        let createProductRes = await postRequest({
            endPoint: shifts.create,
            body: payloads['create']
        })

        if (updatePlantRes.success === true && createProductRes.success === true) {
            let { plant } = getFromLocalStorage('current')
            let plantToUpdate = { ...plant, productSettings: payloads.update.productSettings }
            updatePlants(plantToUpdate, plantToUpdate?._id, dispatch)
            success('Product Updated.')
        }
    }
    catch (exc) {
        notification.error(exc.message)
    }
    dispatch(setComponentLoader({ component: 'productModal', flag: false }))
}

const deleteProduct = async (dispatch, body, current) => {

    dispatch(setComponentLoader({ component: 'productModal', flag: true }))
    let currentUser = getFromLocalStorage('user');
    let { productSettings } = current.plant
    let { rec } = body;
    const newProductSettings = productSettings.filter(item => JSON.stringify(rec) !== JSON.stringify(item));
    let payloads = {
        create: {
            detailsBefore: {
                name: rec?.name,
                sku: rec?.sku,
                primary: rec?.primary,
                secondary: rec?.secondary,
            },
            action: 'Product Updated',
            email: currentUser?.username,
            hallName: current?.hall?.hallName,
            lineName: current?.line?.lineName,
            lineId: current?.line?.id,
            plantName: current?.plant?.plantName,
            plantId: current?.plant?._id,
            shiftName: current?.shift?.name,
            time: `${moment(Date.now()).format(`${"YYYY-MM-DDThh:mm:ss.ms"}`)}Z`,
            userId: "test132",
        },
        update: {
            productSettings: [
                ...newProductSettings,
            ],
            _id: current?.plant?._id,
            updatedAt: `${moment(new Date()).format("YYYY-MM-DDThh:mm:ss.ms")}Z`
        },
    }

    try {

        let updatePlantRes = await postRequest({
            endPoint: plants.update,
            body: payloads['update']
        })


        let createProductRes = await postRequest({
            endPoint: shifts.create,
            body: payloads['create']
        })

        if (updatePlantRes.success === true && createProductRes.success === true) {
            let { plant } = getFromLocalStorage('current')
            let plantToUpdate = { ...plant, productSettings: payloads.update.productSettings }
            updatePlants(plantToUpdate, plantToUpdate?._id, dispatch)
            success('Product Deleted.')
        }
    }
    catch (exc) {
        error(exc.message)
    }
    dispatch(setComponentLoader({ component: 'productModal', flag: false }))
}

const createAlert = async (dispatch, body, current) => {

    dispatch(setComponentLoader({ component: 'alertModal', flag: true }))
    let currentUser = getFromLocalStorage('user');
    let { alertSettings } = current.plant
    let { lineOps } = body;
    let lines = []
    lineOps.forEach((op) => {
        body.lines.forEach((line) => {
            if (line == op.value)
                lines.push({ lineName: op.label, id: op.value })
        })
    })
    let payloads = {
        create: {
            detailsAfter: {
                type: body.type,
                toValue: body.toValue,
                subject: body.subject,
                status: body.status ? 'active' : 'inactive',
                phoneNumber: body.phoneNumber || null,
                medium: body.medium ? 'email' : 'sms',
                lines: lines,
                inactiveTill: `${moment(body.time).format("YYYY-MM-DDThh:mm:ss.ms")}Z`,
                fromValue: body.fromValue,
                emailCC: body.ccEmail,
                emailBCC: body.bccEmail,
                email: body.emailAddress
            },
            action: 'Alert Created',
            email: currentUser?.username,
            hallName: current?.hall?.hallName,
            lineName: current?.line?.lineName,
            lineId: current?.line?.id,
            plantName: current?.plant?.plantName,
            plantId: current?.plant?._id,
            shiftName: current?.shift?.name,
            time: `${moment(Date.now()).format(`${"YYYY-MM-DDThh:mm:ss.ms"}`)}Z`,
            userId: "test132",
        },
        update: {
            _id: current?.plant?._id,
            updatedAt: `${moment(new Date()).format("YYYY-MM-DDThh:mm:ss.ms")}Z`,
            alertSettings: [
                ...alertSettings,
                {
                    type: body.type,
                    toValue: body.toValue,
                    subject: body.subject,
                    status: body.status ? 'active' : 'inactive',
                    phoneNumber: body.phoneNumber || null,
                    medium: body.medium ? 'email' : 'sms',
                    lines: lines,
                    inactiveTill: `${moment(body.time).format("YYYY-MM-DDThh:mm:ss.ms")}Z`,
                    fromValue: body.fromValue,
                    emailCC: body.ccEmail,
                    emailBCC: body.bccEmail,
                    email: body.emailAddress
                }],
        },
    }

    try {

        let updatePlantRes = await postRequest({
            endPoint: plants.update,
            body: payloads['update']
        })


        let createAlertRes = await postRequest({
            endPoint: alerts.create,
            body: payloads['create']
        })

        if (updatePlantRes.success === true && createAlertRes.success === true) {
            let { plant } = getFromLocalStorage('current')
            let plantToUpdate = { ...plant, alertSettings: payloads.update.alertSettings }
            updatePlants(plantToUpdate, plantToUpdate?._id, dispatch)
            success('Alert Created.')
        }
    }
    catch (exc) {
        notification.error(exc.message)
    }
    dispatch(setComponentLoader({ component: 'alertModal', flag: false }))
}

const editAlert = async (dispatch, body, current) => {

    dispatch(setComponentLoader({ component: 'alertModal', flag: true }))
    let currentUser = getFromLocalStorage('user');
    let { alertSettings } = current.plant
    let { lineOps, rec, values } = body;
    let lines = []
    lineOps.forEach((op) => {
        values.lines.forEach((line) => {
            if (line.value) {
                if (line.value == op.value)
                    lines.push({ lineName: op.label, id: op.value })
            }
            else {
                if (line == op.value)
                    lines.push({ lineName: op.label, id: op.value })
            }
        })
    })
    const newAlertSettings = alertSettings.filter(item => JSON.stringify(rec) !== JSON.stringify(item));
    let payloads = {
        create: {
            detailsBefore: { ...rec },
            detailsAfter: {
                type: values.type?.value ? values.type?.value : values.type,
                toValue: values.toValue,
                subject: values.subject,
                status: values.status ? 'inactive' : 'active',
                phoneNumber: values.phoneNumber || null,
                medium: values.medium ? 'email' : 'sms',
                lines: lines,
                inactiveTill: `${moment(values.time).format("YYYY-MM-DDThh:mm:ss.ms")}Z`,
                fromValue: values.fromValue,
                emailCC: values.ccEmail,
                emailBCC: values.bccEmail,
                email: values.emailAddress
            },
            action: 'Alert Updated',
            email: currentUser?.username,
            hallName: current?.hall?.hallName,
            lineName: current?.line?.lineName,
            lineId: current?.line?.id,
            plantName: current?.plant?.plantName,
            plantId: current?.plant?._id,
            shiftName: current?.shift?.name,
            time: `${moment(Date.now()).format(`${"YYYY-MM-DDThh:mm:ss.ms"}`)}Z`,
            userId: "test132",
        },
        update: {
            alertSettings: [
                ...newAlertSettings,
                {
                    type: values.type?.value ? values.type?.value : values.type,
                    toValue: values.toValue,
                    subject: values.subject,
                    status: values.status ? 'active' : 'inactive',
                    phoneNumber: values.phoneNumber || null,
                    medium: values.medium ? 'email' : 'sms',
                    lines: lines,
                    inactiveTill: `${moment(values.time).format("YYYY-MM-DDThh:mm:ss.ms")}Z`,
                    fromValue: values.fromValue,
                    emailCC: values.ccEmail,
                    emailBCC: values.bccEmail,
                    email: values.emailAddress
                }],
            _id: current?.plant?._id,
            updatedAt: `${moment(new Date()).format("YYYY-MM-DDThh:mm:ss.ms")}Z`
        },
    }

    try {

        let updatePlantRes = await postRequest({
            endPoint: plants.update,
            body: payloads['update']
        })


        let createAlertRes = await postRequest({
            endPoint: alerts.create,
            body: payloads['create']
        })

        if (updatePlantRes.success === true && createAlertRes.success === true) {
            let { plant } = getFromLocalStorage('current')
            let plantToUpdate = { ...plant, alertSettings: payloads.update.alertSettings }
            updatePlants(plantToUpdate, plantToUpdate?._id, dispatch)
            success('Alert Updated.')
        }
    }
    catch (exc) {
        notification.error(exc.message)
    }
    dispatch(setComponentLoader({ component: 'alertModal', flag: false }))
}

const deleteAlert = async (dispatch, body, current) => {

    dispatch(setComponentLoader({ component: 'alertModal', flag: true }))
    let currentUser = getFromLocalStorage('user');
    let { alertSettings } = current.plant
    let { rec } = body;
    const newAlertSettings = alertSettings.filter(item => JSON.stringify(rec) !== JSON.stringify(item));
    let payloads = {
        create: {
            detailsBefore: {
                type: rec?.type,
                toValue: rec?.toValue,
                subject: rec?.subject,
                status: rec?.status ? 'inactive' : 'active',
                phoneNumber: rec?.phoneNumber || null,
                medium: rec?.medium ? 'email' : 'sms',
                lines: rec?.lines,
                inactiveTill: `${moment(rec?.time).format("YYYY-MM-DDThh:mm:ss.ms")}Z`,
                fromValue: rec?.fromValue,
                emailCC: rec?.ccEmail,
                emailBCC: rec?.bccEmail,
                email: rec?.emailAddress
            },
            action: 'Alert Updated',
            email: currentUser?.username,
            hallName: current?.hall?.hallName,
            lineName: current?.line?.lineName,
            lineId: current?.line?.id,
            plantName: current?.plant?.plantName,
            plantId: current?.plant?._id,
            shiftName: current?.shift?.name,
            time: `${moment(Date.now()).format(`${"YYYY-MM-DDThh:mm:ss.ms"}`)}Z`,
            userId: "test132",
        },
        update: {
            alertSettings: [
                ...newAlertSettings,
            ],
            _id: current?.plant?._id,
            updatedAt: `${moment(new Date()).format("YYYY-MM-DDThh:mm:ss.ms")}Z`
        },
    }

    try {

        let updatePlantRes = await postRequest({
            endPoint: plants.update,
            body: payloads['update']
        })


        let createAlertRes = await postRequest({
            endPoint: alerts.create,
            body: payloads['create']
        })

        if (updatePlantRes.success === true && createAlertRes.success === true) {
            let { plant } = getFromLocalStorage('current')
            let plantToUpdate = { ...plant, alertSettings: payloads.update.alertSettings }
            updatePlants(plantToUpdate, plantToUpdate?._id, dispatch)
            success('Alert Deleted.')
        }
    }
    catch (exc) {
        error(exc.message)
    }
    dispatch(setComponentLoader({ component: 'alertModal', flag: false }))
}

const onDeleteValidation = async (dispatch, body) => {

    dispatch(setPageLoader({ page: 'validation', flag: true }))
    let response = await postRequest({
        endPoint: plants.update,
        body
    })
    if (response.success === true) {
        let current = getFromLocalStorage('current')
        let plants = getFromLocalStorage('plants')
        let { plant } = current;

        let filteredPlants = plants.filter(data => data._id !== plant?._id)
        plant = { ...plant, validations: body.validations }
        plants = [plant, ...filteredPlants]
        current = { ...current, plant }
        // console.log({ current, plants })
        setToLocalStorage(current, 'current')
        setToLocalStorage(plants, 'plants')
        dispatch(changeValidation({ current, plants }))
    }
    dispatch(setPageLoader({ page: 'validation', flag: false }))

}

const onAddRoleSubmit = async (dispatch, body) => {

    let current = getFromLocalStorage('current')

    dispatch(setPageLoader({ page: 'addRole', flag: true }))
    let response = await postRequest({
        endPoint: roles.create,
        body
    })
    if (response.success === true) {
        dispatch(setRoleList(body))
        // console.log("Role Created")
        getRolesList(dispatch, current)

    }
    dispatch(setPageLoader({ page: 'addRole', flag: false }))

}

const onEditRoleSubmit = async (dispatch, body) => {

    let current = getFromLocalStorage('current')

    dispatch(setPageLoader({ page: 'updateRole', flag: true }))
    let response = await postRequest({
        endPoint: roles.update,
        body
    })
    if (response.success === true) {
        dispatch(setRoleList(body))
        // console.log("Role Updated")
        getRolesList(dispatch, current)
    }
    dispatch(setPageLoader({ page: 'updateRole', flag: false }))

}

const onDeleteRoleSubmit = async (dispatch, selectedRole) => {

    let current = getFromLocalStorage('current')
    let { line = null, plant = null } = current

    if ((plant?.accessControl.find(user => user.role == selectedRole.role))) {
        error("Please reassign the users to another role to delete this role.")
        return
    }

    let response = await deleteRequest({
        endPoint: roles.delete + `id=${selectedRole?._id}&lineId=${line?.id}&plantId=undefined`,
    })
    dispatch(setComponentReloader({ component: 'roles' }))


}




export {
    onAddUserSubmit,
    onDeleteUserSubmit,
    createAlert,
    onValidationSubmit,
    onDeleteValidation,
    onEditUserSubmit,
    onAddRoleSubmit,
    onEditRoleSubmit,
    onDeleteRoleSubmit,
    editAlert,
    deleteAlert,
    createProduct,
    editProduct,
    deleteProduct,
    createPlant,
    deleteRecord,
}